import { Button } from "@/components/ui/button";
import { LinkedInLogoIcon } from "@radix-ui/react-icons";

const linkedInUrl = "https://www.linkedin.com/in/dkatamari/";

export default function BtnLinkedIn() {
    return (
        <Button variant="ghost" size="icon" asChild>
            <a href={linkedInUrl} target="_blank" rel="noreferrer" aria-label="Open LinkedIn profile" className="flex items-center justify-center">
                <LinkedInLogoIcon />
            </a>
        </Button>
    );
}